import { timeAgo } from "@/hooks/useRate";

export default function RateCard({ rate, large = false }) {
    const formatted =
        rate.rate !== null && rate.rate !== undefined
            ? `₹${Number(rate.rate).toFixed(2)}`
            : null;

    return (
        <div
            data-testid="live-rate-card"
            className={`glass rounded-2xl relative overflow-hidden rate-card-glow ${
                rate.change === "up"
                    ? "rate-flash-up"
                    : rate.change === "down"
                      ? "rate-flash-down"
                      : ""
            } ${
                large ? "p-6 sm:p-10" : "p-5 sm:p-6"
            }`}
        >
            <div className="pointer-events-none absolute -top-16 -right-16 w-48 h-48 rounded-full bg-[#3EC6F0]/15 blur-[70px]" />
            <div className="absolute top-0 inset-x-6 rate-hairline" aria-hidden="true" />

            <div className="relative flex items-center justify-between gap-3">
                <span className="text-[11px] sm:text-xs uppercase tracking-[0.2em] text-[#1E56FF] font-bold">
                    Live USDT Rate
                </span>
                <span
                    data-testid="live-indicator"
                    className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wider ${
                        rate.live
                            ? "bg-emerald-50 text-emerald-600 border border-emerald-200"
                            : "bg-slate-100 text-slate-500 border border-slate-200"
                    }`}
                >
                    {rate.live && <span className="live-dot" />}
                    {rate.live ? "Live" : rate.loading ? "Connecting" : "Reconnecting"}
                </span>
            </div>

            <div className="relative mt-3 flex items-end gap-2 flex-wrap">
                {formatted ? (
                    <>
                        <span
                            data-testid="live-rate-value"
                            className={`font-display font-extrabold text-gradient leading-none rate-value ${
                                large ? "text-5xl sm:text-7xl" : "text-4xl sm:text-5xl"
                            }`}
                        >
                            {formatted}
                        </span>
                        <span
                            className={`text-[#5B6B8C] font-semibold pb-1 ${
                                large ? "text-base sm:text-lg" : "text-sm"
                            }`}
                        >
                            / USDT
                        </span>
                    </>
                ) : (
                    <span
                        data-testid="live-rate-loading"
                        className={`rate-skeleton rounded-xl ${
                            large ? "h-14 sm:h-20 w-56 sm:w-72" : "h-11 w-44"
                        }`}
                        aria-label="Fetching live rate"
                    />
                )}
            </div>

            <p
                data-testid="live-rate-updated"
                className="relative mt-3 text-xs text-[#8494B0]"
            >
                {rate.updatedAt
                    ? `Last updated ${timeAgo(rate.updatedAt)} · Source: DtOrbit`
                    : "Fetching the current rate from DtOrbit…"}
            </p>
        </div>
    );
}
